import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';

const AlumniProfileMeters = ({ engagementData }: any) => {
    const meters = [
        {
            label: 'Alma Mater Pride',
            key: 'alma_mater_pride',
            tooltipKey: 'tooltip_alma_mater_pride',
            rotate: {
                LOW: '-80deg',
                MODERATE: '0deg',
                HIGH: '80deg',
            },
        },
        {
            label: 'Marketability Quotient',
            key: 'marketability',
            tooltipKey: 'tooltip_marketability',
            rotate: {
                LOW: '-80deg',
                MODERATE: '0deg',
                HIGH: '80deg',
            },
        },
        {
            label: 'Vibrancy Level',
            key: 'vibrancy',
            tooltipKey: 'tooltip_vibrancy',
            rotate: {
                LOW: '-80deg',
                MODERATE: '0deg',
                HIGH: '80deg',
            },
        },
    ];

    const circularScores = [
        {
            label: 'Donor Score',
            key: 'donor_score',
            tooltipKey: 'tooltip_donor',
            imgSrc: 'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/circle-meter-1.png',
        },
        {
            label: 'Mentorship Score',
            key: 'mentorship_score',
            tooltipKey: 'tooltip_mentorship',
            imgSrc: 'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/circle-meter-2.png',
        },
        {
            label: 'Recruiter Score',
            key: 'recruiter_score',
            tooltipKey: 'tooltip_recruiter',
            imgSrc: 'https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/circle-meter-3.png',
        },
    ];

    const getMeterRotation = (value: string, rotateMap: any) => {
        return rotateMap?.[value?.toUpperCase()] ?? '0deg';
    };

   const allTooltips = [
        ...meters.map(m => ({
            label: m.label,
            text: engagementData?.[m.tooltipKey] || '',
        })),
        ...circularScores.map(s => ({
            label: s.label,
            text: engagementData?.[s.tooltipKey] || '',
        })),
    ];

    const combinedTooltipText = 
    "Each alumnus' profile information, distributed knowledge from institute, campaign activities, platform activities, phone call interactions with Univariety team, social media activities and various empirical data points are analysed to generate scores for relevant alumni metrics";

    const [modalHeader, setModalHeader] = useState('');
    const [modalData, setModalData] = useState('');
    const [modalText, setModalText] = useState('');
    const [modalLevelText, setModalLevelText] = useState('');
    const [modalScore, setModalScore] = useState<number | null>(null);
    const [showModal, setShowModal] = useState(false);

    const modal_text: Record<string, string> = {
        tooltip_alma_mater_pride : `It is an indicator of alumni's actions that demonstrates that they feel some sense of pride and belongingness in being associated with the institution, and don't shy away from displaying it to the world.`,
        tooltip_marketability : `It is an indicator of alumni's present stature based on their profile strength and actions, that makes them appealing for current students, prospects seeking admissions, ranking bodies and recruiting companies.`,
        tooltip_vibrancy : `It is an indicator of the engagement potential of the alumni. It is derived from profile completion percentage, actions and interactions on the alumni portal, social media activity, physical visits, telephone calls, and digital engagement interaction levels.`,
        tooltip_donor : `It is a function of alumni's "ability to donate" in general as well as "willingness to actually donate" for the institute. Ability comes from the work profile, position strength and relevant demographic markers, while willingness is gauged through affinity markers and targeted outreach for fundraise.`,
        tooltip_mentorship : `It is a function of alumni's "ability to guide and mentor" others as well as "willingness to actually act as a mentor" for current students or other alumni on their areas of expertise. Ability comes from the work profile, skills and areas of expertise, while willingness is gauged through targeted outreach for mentorship.`,
        tooltip_recruiter : `It is a function of alumni's "ability to recruit" someone for a job or internship as well as "willingness to actually recruit" from the institute. Ability comes from the work profile, position strength and relevant demographic markers, while willingness is gauged through affinity markers and targeted outreach for recruitment.`
    }

    const openToolTipModal = (key: any, label: any, score: any) => {
        setModalHeader(label);
        setModalText(modal_text[key] || '');
        setModalData(engagementData ? engagementData[key] : 'No data Available');

        if (typeof score === 'string' && ['LOW','MODERATE','HIGH'].includes(score.toUpperCase())) {
            setModalLevelText(score.toUpperCase());
            setModalScore(null);
        } else {
            // numeric
            const numericScore = parseInt(score.replace('%',''), 10);
            setModalLevelText('');
            setModalScore(numericScore);
        }

        setShowModal(true);
        };

    return (
        <div className="col-12 ">
            <div className='bg-white bg-gradient bg-opacity-75 radius-6 px-3 py-4 position-relative mt-3 shadow--sm'>
            <i className="icon-info position-absolute top-10 right-10 text-gray-64" 
                data-bs-toggle="tooltip"
                data-bs-original-title={combinedTooltipText}
                aria-label={combinedTooltipText}
                >
            </i>
            <div className="row g-3 g-md-5 justify-content-around">
                {meters.map((meter, index) => {
                    const level = engagementData?.[meter.key]
                    ? engagementData[meter.key].toUpperCase()
                    : 'LOW';

                    const tooltipText = (engagementData?.[meter.tooltipKey] ?? '').replace(/<br\s*\/?>/gi, '\n');
                    const rotation = getMeterRotation(level, meter.rotate);

                    return (
                        <div className="col-6 col-sm-auto cursor-pointer" key={index} onClick={() => {openToolTipModal(meter?.tooltipKey, meter?.label, level)}}>
                            <div className="position-relative">
                            </div>
                            <div className="new-meter-wrap">
                                <div className="new-meter mb-2">
                                    <img
                                        src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/multi-color.svg"
                                        className="img-fluid"
                                        width="100"
                                        alt=""
                                    />
                                    <div
                                        className="new-meter-pointer"
                                        style={{ transform: `rotate(${rotation})` }}
                                    >
                                        <img
                                            src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/meter-pointer.svg"
                                            width="100"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div className="font-14 font-600 text-center">{level}</div>
                            </div>
                            <div className="font-14 font-600 text-center mt-1 text-blue-0C4CBB">{meter.label}</div>
                        </div>
                    );
                })}

                {circularScores.map((score, index) => {
                    const percent = engagementData?.[score.key] ?? 0;
                    const tooltip = (engagementData?.[score.tooltipKey] ?? '').replace(/<br\s*\/?>/gi, '\n');
                    return (
                        <div className="col-6 col-sm-auto cursor-pointer" key={index} onClick={() => {openToolTipModal(score?.tooltipKey, score?.label, percent+'%')}}>
                            <div className="circle-graph">
                               <CircularProgressbar
                                value={percent}
                                text={`${percent}%`}
                                styles={buildStyles({
                                    textSize: '16px',
                                    pathColor: '#5CAE48', 
                                    textColor: '#000',
                                    trailColor: '#eee',
                                })}
                                />
                            </div>
                            <div className="font-14 font-600 text-center mt-1 text-blue-0C4CBB">{score.label}</div>
                        </div>
                    );
                })}
            </div>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Modal.Header closeButton>
                <Modal.Title>{modalHeader}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='mb-3 bg-gray-f2 p-3 radius-6 border-1 border-gray-E3E6E8'>
                    <p className='mb-0'>{modalText}</p>
                    </div>

                    <div className='row g-2 mb-3 align-items-center'>
                        {modalLevelText && (
                            <div className="col-auto">
                            <div className={`font-14 font-500 text-center mt-1 badge rounded-pill px-3 py-2 
                                ${modalLevelText === 'LOW' ? 'bg-danger' : modalLevelText === 'MODERATE' ? 'bg-info' : 'bg-success'}`}>
                                {modalLevelText}
                            </div>
                            </div>
                        )}

                        {modalScore !== null && (
                            <div className="col-auto">
                            <div className="font-18 font-500">
                                Score - 
                                <span className={`font-600 ${
                                modalScore < 45 ? 'text-burgandi' 
                                : modalScore < 60 ? 'text-sky-blue' 
                                : 'text-green'
                                }`}>
                                {' '+modalScore}%
                                </span>
                            </div>
                            </div>
                        )}
                    </div>

                    <div className='mb-3' dangerouslySetInnerHTML={{ __html: modalData }} />
                  
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AlumniProfileMeters;
